var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"variant":"warning","show":""}},[_c('div',{staticClass:"alert-body text-center"},[_c('FeatherIcon',{attrs:{"icon":"InfoIcon"}}),_c('p',[_vm._v("Kayıt bulunamadı.")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }